module.exports = __webpack_public_path__ + "img/projects-ats.2758496a.jpg";